import { ReactNode } from 'react'
import './Empty.css';

export default function Empty({ children }: { children: ReactNode }) {
  return (
    <p className="empty">
      {children}
    </p>
  )
}
